import React, { useMemo } from 'react';
import { Box, Preloader, useResponsive } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { MobilePageModalWrapper, ModalWrapper } from '@/components/wrappers';
import { useStatesQuery } from '@/modules/core/queries';

import AddBeneficiaryForm from './AddBeneficiaryForm';
import useBeneficiaryRelationshipsTypesQuery from './useBeneficiaryRelationshipsTypes.query';
import { Beneficiary, BeneficiaryType } from './useGetBeneficiaries.query';

interface Props {
  onClose: () => void;
  beneficiaries?: Beneficiary[];
  beneficiaryType?: BeneficiaryType;
}

const AddBeneficiaryModal: React.FC<Props> = ({ beneficiaries, beneficiaryType, onClose }) => {
  const { isMobile } = useResponsive();
  const { formattedRelationshipsTypes, isLoading } = useBeneficiaryRelationshipsTypesQuery();
  const { states, isLoading: areStatesLoading } = useStatesQuery();
  const typeTitle = useMemo(() => capitalize(beneficiaryType), [beneficiaryType]);
  const editTitle = useMemo(
    () => (beneficiaries?.length ? `Edit ${typeTitle} Beneficiaries` : `Add a ${typeTitle} Beneficiary`),
    [beneficiaries, typeTitle]
  );

  const content =
    isLoading || areStatesLoading ? (
      <Preloader testId="AddBeneficiaryModal" />
    ) : (
      <AddBeneficiaryForm
        beneficiaries={beneficiaries}
        beneficiaryType={beneficiaryType}
        onClose={onClose}
        relationshipsTypes={formattedRelationshipsTypes}
        states={states}
      />
    );

  if (isMobile) {
    return (
      <MobilePageModalWrapper title={editTitle} isVisible onSetVisible={() => onClose()}>
        <Box pad={{ horizontal: 'spacing2' }}>{content}</Box>
      </MobilePageModalWrapper>
    );
  }

  return (
    <ModalWrapper
      testId={`AddOrEditBeneficiaryModal_${beneficiaryType}`}
      visible
      title={editTitle}
      onSetVisible={() => onClose()}
    >
      {content}
    </ModalWrapper>
  );
};

export default AddBeneficiaryModal;
